export const MAIN_CLASS_NAME = 'status-dropdown';
export const BUTTON_CLASS_NAME = `${MAIN_CLASS_NAME}__button`;
export const OVERLAY_CLASS_NAME = `${MAIN_CLASS_NAME}__overlay`;
export const ICON_CLASS_NAME = `${BUTTON_CLASS_NAME}__icon`;
export const TITLE_CLASS_NAME = `${BUTTON_CLASS_NAME}__title`;
